module.exports = __webpack_public_path__ + "img/login_bg.d56a4df1.png";